export default __webpack_public_path__ + "static/media/CricketTonic.97b6c66b4ac38f342928312b6b92d95a.webp";